function htm(selector,content){
    let current = [];

    function self(selector,content){
        if(typeof selector === 'string' && selector.trim() !== ''){
            current.push(['<', selector, '>',content || '','</', selector.split(' ')[0], '>'].join(''));
        }
        return self;
    }

    self.toString = () => current.join('');

    Object.defineProperty(self, 'Nodes', {
        get() { 
            let template = document.createElement('div');
            template.innerHTML = self.toString();
            return template.childNodes;
        }
    });

    Object.defineProperty(self, 'Node', {
        get() { 
            return this.Nodes.length === 1 ? this.Nodes[0] : document.createRange().createContextualFragment(self.toString());
        }
    });

    return self(selector,content);
}

export default htm;